

function Success(){
    return(
        <h1>Success! Thank you for your payment to Stripe!</h1>
    )
}

export default Success;